// extracted by mini-css-extract-plugin
export default {"dataTable":"dataTable__tz8gPlac","hover":"hover__y3RiljOd","ctaButtons":"ctaButtons__egFTwIx2","deleteButton":"deleteButton__q5I7wpJB","editButton":"editButton__BzzimYtT"};